export default __webpack_public_path__ + "static/media/BlogImage2.50fbea87.png";